import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isUndefined } from "@utils/helpers/typeHelper";

const loanRouteController = ({navigators, previousMatch, setPreviousMatch, state, navigate, pathname, queryString}) => {
  const match = navigators.find(navigator => navigator.shouldRouteBeActive(state, pathname));
  const { utm_source, theme } = queryString || {};
  const cleanQueryString = { theme: (theme || utm_source)};

  if (!isUndefined(match)) {
    if (previousMatch !== match) {
      setPreviousMatch(match);
      match.navigateTo(navigate, state, cleanQueryString);
    }
  }
};

export const useLoanRouteController = (navigators, state, isEnabled = true) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [ previousMatch, setPreviousMatch ] = useState();
  const { queryString } = useSelector(s => s.StartUp);


  useEffect(() => {
    if (isEnabled) {
      loanRouteController({navigators, previousMatch, setPreviousMatch, state, navigate, pathname, queryString});
    }
  }, [
    navigate,
    pathname,
    state,
    navigators,
    previousMatch,
    setPreviousMatch,
    queryString,
    isEnabled
  ])
};

export default useLoanRouteController;

export const __TEST__ = {
  loanRouteController,
}